<Title date="2024-12-07" slug="license" basePath="docs">
  License
</Title>

SOFTWARE LICENSE AGREEMENT

IMPORTANT - READ CAREFULLY: This Software License Agreement ("Agreement") is a legal agreement between you (as an individual developer, not a company or organization) and Enzo Manuel Mangano ("Licensor") for the software product identified above, which includes computer software and may include associated media, printed materials, and "online" or electronic documentation ("Software").

NOTE: This license is valid for individual developers only. Company licenses are not currently available. Companies interested in licensing this software must contact hello@reactiive.io to discuss licensing options privately.

BY INSTALLING, COPYING, OR OTHERWISE USING THE SOFTWARE, YOU AGREE TO BE BOUND BY THE TERMS OF THIS AGREEMENT. IF YOU DO NOT AGREE TO THE TERMS OF THIS AGREEMENT, DO NOT INSTALL OR USE THE SOFTWARE.

1. GRANT OF LICENSE
   Subject to the terms and conditions of this Agreement, Licensor hereby grants you a non-exclusive, non-transferable license to use the Software under the following conditions:

   1.1 PERMITTED USES (FOR INDIVIDUAL DEVELOPERS ONLY):
   a) Implementation of the animations and UI components within your applications;
   b) Modification and customization of the components for your specific requirements;
   c) Deployment across multiple projects within your licensed scope.

   1.2 EXPLICIT RESTRICTIONS:
   You shall not, and shall not permit others to:
   a) Use this license for company or organizational purposes (company licenses are not currently available);
   b) Resell, redistribute, or sublicense the Software code in its original form;
   c) Create or develop competing animation libraries using the Software components;
   d) Extract individual components for standalone distribution;
   e) Port or translate the components to other frameworks for redistribution purposes;
   f) Remove or alter any proprietary notices or marks on the Software.

2. INTELLECTUAL PROPERTY RIGHTS
   The Software is protected by copyright laws and international copyright treaties, as well as other intellectual property laws and treaties. The Software is licensed, not sold. Licensor retains all rights, title, and interest in and to the Software, including all intellectual property rights.

3. TERM AND TERMINATION
   This Agreement is effective until terminated. Your rights under this Agreement will terminate automatically without notice if you fail to comply with any term(s) of this Agreement. Upon termination of this Agreement, you shall cease all use of the Software and destroy all copies, full or partial, of the Software.

4. NO WARRANTIES
   THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.

5. LIMITATION OF LIABILITY
   TO THE MAXIMUM EXTENT PERMITTED BY APPLICABLE LAW, IN NO EVENT SHALL LICENSOR BE LIABLE FOR ANY SPECIAL, INCIDENTAL, INDIRECT, OR CONSEQUENTIAL DAMAGES WHATSOEVER (INCLUDING, WITHOUT LIMITATION, DAMAGES FOR LOSS OF BUSINESS PROFITS, BUSINESS INTERRUPTION, LOSS OF BUSINESS INFORMATION, OR ANY OTHER PECUNIARY LOSS) ARISING OUT OF THE USE OF OR INABILITY TO USE THE SOFTWARE.

6. GOVERNING LAW
   This Agreement shall be governed by and construed in accordance with the laws of the jurisdiction in which Licensor operates, without giving effect to any principles of conflicts of law.

7. ENTIRE AGREEMENT
   This Agreement constitutes the entire agreement between the parties with respect to the use of the Software and supersedes all prior or contemporaneous understandings regarding such subject matter.

Copyright (c) 2024 Enzo Manuel Mangano
All rights reserved.
